import { Button } from "@legal-500/legal500-design-system";
import styles from "./MailingGroups.module.css";

type Props = {
  count: number;
  // True while the confirm dialog is open — disables the bar to block a
  // double-open (the dialog owns its own "Processing…" state on confirm).
  busy: boolean;
  onClear: () => void;
  onResend: () => void;
};

// Sticky bar pinned to the bottom of the Candidates panel while failed
// recipients are selected. Mirrors SelectionActionBar (create-send) but drives
// the resend flow instead — the two are mutually exclusive (mode-switched by
// the "Failed" send-status filter), so only one is ever mounted.
export function ResendActionBar({ count, busy, onClear, onResend }: Props) {
  if (count <= 0) return null;

  return (
    <div className={styles.actionBar}>
      <div className={styles.actionBarCount}>
        <b>{count.toLocaleString()}</b> failed recipient{count === 1 ? "" : "s"} selected{" "}
        <span className={styles.actionBarSub}>· will be re-sent</span>
      </div>
      <div className={styles.actionBarActions}>
        <Button variant="outlined" color="primary" size="small" disabled={busy} onClick={onClear}>
          Clear
        </Button>
        <Button variant="contained" color="primary" size="small" disabled={busy} onClick={onResend}>
          Resend selected
        </Button>
      </div>
    </div>
  );
}
